import React from 'react';

import { EmptyContainer, EmptyText } from './DataCard.styled';

interface IProps {
  message: string;
}

export const EmptyDataCard = ({ message }: IProps) => {
  return (
    <EmptyContainer>
      <EmptyText>{message}</EmptyText>
    </EmptyContainer>
  );
};
